/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import routerLoader from '../../../i18n/router';
import { TarjetaService } from '../../../services';
import { useAppStore } from '../../../store/AppContext';
import { InfoUsuarioOro } from '../../../types/Types';
import { StorageHelper } from '../../../utils/StorageHelper';
import { TarjetaOroHelper } from '../../TarjetasOro/TarjetaOroHelper';
import { TarjetasOroConstants } from '../../TarjetasOro/TarjetasOroConstants';

interface Props {
  setShowFormModalidad: (show: boolean) => void;
  setCuotaAltaSelected: (show: boolean) => void;
}
const GestionesOro: FC<Props> = (props) => {
  const [showCambiarCuota, setShowCambiarCuota] = useState<boolean>(true);
  const [infoUsuarioOro, setInfoUsuarioOro] = useState<InfoUsuarioOro>();
  const { setShowFormModalidad, setCuotaAltaSelected } = props;
  const { t } = useTranslation();
  const dataApp = useAppStore();

  const getInfoUsuarioOro = () => {
    TarjetaService.getInfoUsuarioOro()
      .then((response) => {
        if (!response.data.error) {
          setInfoUsuarioOro(response.data.pojo);
          setShowCambiarCuota(
            TarjetaOroHelper.getShowCambiarCuota(response.data.pojo),
          );
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const manageOro = () => {
    StorageHelper.setOpenV2P(false);
    window.location.href = routerLoader.LoadRouterByPath(
      'tarjeta-oro',
      dataApp.lang,
    );
  };

  useEffect(() => {
    getInfoUsuarioOro();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!StorageHelper.isEcommerceBot()) {
    return (
      <>
        <h2 className="bloque-datos__title">
          <span className="divider__square brand-gold-color" />
          <span className="u-margin-right">
            {infoUsuarioOro?.isEmpresaOro
              ? t('tarjetas.tarjeta-oro-datos.empresa-oro')
              : t('tarjetas.tarjeta-club-mastercard-oro.gold-card')}
          </span>
        </h2>

        <div className="u-display-flex-tablet u-justify-content-space-between">
          {(() => {
            if (showCambiarCuota) {
              return (
                <div className="bloque-socio">
                  <p className="title__medium u-margin-bottom-small">
                    {t('tarjetas.tarjeta-club-mastercard-oro.change-fee')}
                  </p>
                  <p>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      href=""
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setShowFormModalidad(true);
                        setCuotaAltaSelected(
                          infoUsuarioOro?.tipoCuota ===
                            TarjetasOroConstants.TIPO_CUOTA_6,
                        );
                      }}
                      className="link link-oro link-demi"
                    >
                      {t('tarjetas.tarjeta-club-mastercard-oro.change')}
                    </a>
                  </p>
                </div>
              );
            }
            return false;
          })()}

          <div className="bloque-socio">
            <p className="title__medium u-margin-bottom-small">
              {infoUsuarioOro?.isEmpresaOro
                ? t('tarjetas.tarjeta-club-oro.state-oro-empresa')
                : t('tarjetas.tarjeta-club-mastercard-oro.do-other-management')}
            </p>
            <p>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                href=""
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  manageOro();
                }}
                className="link link-oro link-demi"
              >
                {infoUsuarioOro?.isEmpresaOro
                  ? t('tarjetas.tarjeta-club-oro.ver-estado')
                  : t('tarjetas.tarjeta-club-mastercard-oro.manage')}
              </a>
            </p>
          </div>
        </div>
      </>
    );
  }
  return <></>;
};

export default GestionesOro;
